<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    label="バージョン"
    itemName="name"
    :items="items"
    :initial-item-id="props.initialItemId"
    :error-messages="errorMessages"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import FirmwareVersionsType from '@/types/FirmwareVersionsType';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';

const props = defineProps<{
  modelValue: FirmwareVersionsType | undefined;
  initialItemId?: number;
  errorMessages?: string[];
}>();

const emit = defineEmits(['update:modelValue']);

const items = ref<FirmwareVersionsType[]>([]);

onMounted(() => {
  Api()
    .autoCompleteFirmwaresVersions()
    .then((data) => {
      items.value = data;
    });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
